import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Button from 'material-ui/Button'
import { forgotPassword } from '../modules/authProfile'
import { CircularProgress } from 'material-ui/Progress'
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import FormPasswordToggleField from './formPasswordToggleField';
import FormTextField from './formTextField';
import green from 'material-ui/colors/green'
import Messages from '../constants/messages'
import PasswordRequirements from './passwordRequirements'
import { preserveReduxFormValueOnToggle } from '../modules/forgotPasswordResetForm'
import Typography from 'material-ui/Typography'
import withStyles from 'material-ui/styles/withStyles'
import { required, match, notContainEmail, notContainFirstName, notContainLastName, strength } from '../utils/validationRules'

const PROP_TYPES = {
  completedMessage: PropTypes.string,
  expirationMessage: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  partner: PropTypes.string.isRequired,
  preserveReduxFormValueOnToggle: PropTypes.func.isRequired,
  forgotPassword: PropTypes.func,
  userId: PropTypes.string.isRequired
}

const styles = theme => ({
  button: {
    minWidth: 150,
    maxWidth: 300,
    width: '60%',
    marginTop: 25
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '73%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  form: {
    padding: '0 10%',
    textAlign: 'center'
  },
  footer: {
    marginTop: '1em',
    textAlign: 'center'
  },
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3
  }),
  partner: {
    fontSize: '1.1em',
    textAlign: 'center'
  },
  requirements: {
    padding: '1em 7%'
  },
  text: {
    marginLeft: '1em'
  },
  wrapper: {
    position: 'relative'
  }
})

export class ForgotPasswordResetForm extends Component {

  renderContents() {
    const {
      classes,
      initialValues,
      isSubmitting,
      partner,
      preserveReduxFormValueOnToggle,
      forgotPassword,
      handleSubmit,
      password,
      userId } = this.props

    return (
      <div>
        <Typography data-test-id="partnerName" className={classes.partner}>
          {partner}
        </Typography>
        <Typography className={classes.requirements}>
          <div className={classes.text}>
            {Messages['uiComponents']['PASSWORD_REQUIREMENTS_LABEL']}
          </div>
          <PasswordRequirements email={initialValues.email} firstName={initialValues.firstName} lastName={initialValues.lastName} password={password} />
        </Typography>
        <form
          className={classes.form}
          onSubmit={handleSubmit((formValues) => {
            forgotPassword(userId, formValues)
          })}>
          <Field
            disabled={true}
            name="question"
            component={FormTextField}
            label={Messages['uiComponents']['SECURITY_QUESTION_LABEL']}
            type="text" />
          <Field
            disabled={isSubmitting}
            name="answer"
            preserveReduxFormValueOnToggle={preserveReduxFormValueOnToggle}
            component={FormPasswordToggleField}
            label={Messages['uiComponents']['ANSWER_LABEL']}
            validate={[required]} />
          <Field
            disabled={isSubmitting}
            name="password"
            type="password"
            label={Messages['uiComponents']['NEW_PASSWORD_LABEL']}
            component={FormTextField}
            validate={[required, strength, notContainEmail, notContainFirstName, notContainLastName]} />
          <Field
            disabled={isSubmitting}
            name="matchingPassword"
            type="password"
            label={Messages['uiComponents']['NEW_PASSWORD_CONFIRMATION']}
            component={FormTextField}
            validate={[required, match]} />
          {/* Hidden email field required for password validation (see Redux-form docs) */}
          <Field
            name="email"
            component="input"
            type="hidden" />
          <div className={classes.wrapper}>
            <Button
              data-test-id="submit"
              className={classes.button}
              type="submit"
              raised
              color="primary"
              disabled={isSubmitting}>
              {Messages['uiComponents']['CHANGE_BUTTON']}
            </Button>
            { isSubmitting && <CircularProgress size={24} className={classes.buttonProgress} />}
          </div>
          <Typography className={classes.footer} data-test-id="securityChallengeFooter">
            {Messages['pageMessages']['SECURITY_CHALLENGE_FORGOT_MSG']}
          </Typography>
        </form >
      </div>
    )
  }

  render() {
    return (
      this.renderContents()
    )
  }
}

ForgotPasswordResetForm.propTypes = PROP_TYPES

const selector = formValueSelector('forgotPasswordResetForm')

const mapStateToProps = state => ({
  initialValues: state.forgotPasswordResetForm.initialValues,
  isSubmitting: state.forgotPasswordResetForm.isSubmitting,
  isLoading: state.loading.isLoading,
  password: selector(state, 'password')
})

const mapDispatchToProps = dispatch => bindActionCreators({
  preserveReduxFormValueOnToggle,
  forgotPassword
}, dispatch)

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    form: 'forgotPasswordResetForm',
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
  })
)(ForgotPasswordResetForm)
